<template>

    <div>
        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fs">
            <builderall-icon code='arrow-left' class="ba-color-blue1" @click="$emit('setComponent', 'multiActionList')"
                style="cursor: pointer;"></builderall-icon>
            <div class="ba-w-100 ba-flex ba-jc-center">
                <span class="ba-montserrat-600">{{ action.name }}</span>
            </div>
        </div>
        <div class="ba-card ba-blue ba-no-shadow ba-w-100">
            <div class="ba-flex ba-gp-1 ba-jc-fs ba-ai-center ba-w-100">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="1" v-model="action.rotator"
                        :checked="action.rotator" id="flexCheckDefault">
                    <label class="ba-custom-label" for="flexCheckDefault">
                        {{ $t("ct-enable-rotator") }}
                    </label>
                </div>
            </div>
            <div class="ba-w-100 ba-grid" v-for="(item, index) in action.content" :key="index">
                <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
                    <div class="ba-grid ba-w-100">
                        <label class="ba-custom-label">{{ $t("ct-order") }}</label>
                        <input type="number" class="ba-input ba-md" v-model="item.order" required
                            @change="changeOrderActions(item.order, index)" />
                    </div>
                    <div class="ba-grid ba-w-100">
                        <label class="ba-custom-label">{{ $t("ct-clicks") }}</label>
                        <input required type="number" class="ba-input ba-md" v-model="item.clicks" />
                    </div>
                    <div class="ba-grid ba-w-100">
                        <label class="ba-custom-label">{{ $t("ct-action") }}</label>
                        <input type="url" class="ba-input ba-md" required v-model="item.action" />
                    </div>
                    <i class="svg-icon svgi-plus" style="cursor: pointer;" @click="addAction()"></i>
                    <div>
                        <button v-if="index !== 0" class='ba-btn ba-btn-trash ba-sm ba-rounded'
                            @click="removeAction(index)">
                            <builderall-icon code='trash' />
                        </button>
                        <div v-else style="width: 30px;">
                        </div>
                    </div>
                </div>
            </div>
            <hr class="ba-hr-row hr" />
            <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                <button class="ba-btn ba-blue ba-md" @click.prevent="save">
                    {{ $t("ct-save") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { getOne, update } from "../../../js/services/editor/multiactions";

export default {
    name: "MultiActionEdit",
    props: ['action_id'],
    data() {
        return {
            action: {
                name: "",
                description: "",
                content: [],
                action_id: null,
            },
        };
    },
    methods: {
        save() {
            let vm = this;
            this.$emit('loading', true);

            let maxClicks = 0
            this.action.content.forEach(action => { maxClicks = maxClicks + parseInt(action.clicks) })

            let obj = JSON.parse(JSON.stringify(this.action));
            obj.content = JSON.stringify(obj.content);
            obj.max_counter = maxClicks;

            update(obj)
                .then((response) => {
                    this.$snotify.success(this.$t("ct-saved-successfully"));
                    this.$emit('loading', false);
                })
                .finally(() => this.$emit('loading', false));
        },

        toggleRotator() {
            this.action.rotator = !this.action.rotator
        },


        addAction() {
            this.action.content.push({
                order: this.action.content.length + 1,
                action: "https://",
                clicks: 100,
            });
        },

        changeOrderActions(order, index) {
            if (order > this.action.content.length || order < 0) {
                order = this.action.content.length;
            }

            this.action.content.splice(order - 1, 0, this.action.content.splice(index, 1)[0]);
            this.orderActions();
        },

        removeAction(index) {
            this.action.content.splice(index, 1);
            this.orderActions();
        },

        orderActions() {
            this.action.content.forEach((action, index) => (action.order = index + 1));
        },
    },
    mounted() {
        this.$emit('loading', true)
        getOne(this.action_id)
            .then((response) => {
                this.action = response.data.data;
                this.action.content = this.action.content !== " " ? JSON.parse(this.action.content) : [];
                if (typeof this.action.content === 'string') {
                    this.action.content = JSON.parse(this.action.content);
                }
                if (!this.action.content) {
                    this.action.content = []
                }

                if (this.action.content.length == 0) {
                    this.addAction()
                }
                this.$emit('loading', false)
            })
            .finally(() => this.$emit('loading', false));
    },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/MultiActionsEdit.vue